import { render, staticRenderFns } from "./lossWeightDrug.vue?vue&type=template&id=eb07f9b8&scoped=true&"
import script from "./lossWeightDrug.vue?vue&type=script&lang=js&"
export * from "./lossWeightDrug.vue?vue&type=script&lang=js&"
import style0 from "./lossWeightDrug.vue?vue&type=style&index=0&id=eb07f9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb07f9b8",
  null
  
)

export default component.exports